import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DashboardHeader = ({ 
  viewMode, 
  onViewModeChange, 
  onNewContract, 
  selectedContracts, 
  onBulkAction,
  totalContracts,
  filteredContracts 
}) => {
  const bulkActions = [
    { value: 'export', label: 'Export Selected', icon: 'Download' },
    { value: 'archive', label: 'Archive Selected', icon: 'Archive' },
    { value: 'delete', label: 'Delete Selected', icon: 'Trash2' },
  ];

  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
      {/* Left Section - Title and Stats */}
      <div className="flex-1">
        <div className="flex items-center space-x-3 mb-2">
          <h1 className="text-2xl font-bold text-foreground">Contract Dashboard</h1>
          <div className="flex items-center space-x-2 px-3 py-1 bg-muted rounded-full">
            <Icon name="FileText" size={14} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">
              {filteredContracts} of {totalContracts} contracts
            </span>
          </div>
        </div>
        <p className="text-muted-foreground">
          Manage and track all your legal contracts in one centralized location
        </p>
      </div>
      {/* Right Section - Actions and Controls */}
      <div className="flex items-center space-x-3">
        {/* Bulk Actions */}
        {selectedContracts?.length > 0 && (
          <div className="flex items-center space-x-2 px-3 py-2 bg-primary/10 border border-primary/20 rounded-md">
            <span className="text-sm text-primary font-medium">
              {selectedContracts?.length} selected
            </span>
            <div className="flex items-center space-x-1">
              {bulkActions?.map((action) => (
                <Button
                  key={action?.value}
                  variant="ghost"
                  size="xs"
                  onClick={() => onBulkAction(action?.value)}
                  title={action?.label}
                >
                  <Icon name={action?.icon} size={14} />
                </Button>
              ))}
            </div>
          </div>
        )}

        {/* View Toggle */}
        <div className="flex items-center bg-muted rounded-md p-1">
          <Button
            variant={viewMode === 'grid' ? 'default' : 'ghost'}
            size="xs"
            onClick={() => onViewModeChange('grid')}
            title="Grid View"
          >
            <Icon name="Grid3X3" size={14} />
          </Button>
          <Button
            variant={viewMode === 'list' ? 'default' : 'ghost'}
            size="xs"
            onClick={() => onViewModeChange('list')}
            title="List View"
          >
            <Icon name="List" size={14} />
          </Button>
        </div>

        {/* Sort Options */}
        <Button
          variant="outline"
          size="sm"
          iconName="ArrowUpDown"
          iconPosition="left"
        >
          Sort
        </Button>

        {/* New Contract Button */}
        <Button
          variant="default"
          size="sm"
          onClick={onNewContract}
          iconName="Plus"
          iconPosition="left"
        >
          New Contract
        </Button>
      </div>
    </div>
  );
};

export default DashboardHeader;